import { ReturnPolicyView } from "../../views/PolicyCenter/ReturnPolicyView";

export default ReturnPolicyView;
